import { render } from "./FulfillmentOverview.vue?vue&type=template&id=73e2bb3d&scoped=true&ts=true"
import script from "./FulfillmentOverview.vue?vue&type=script&lang=ts"
export * from "./FulfillmentOverview.vue?vue&type=script&lang=ts"

import "./FulfillmentOverview.vue?vue&type=style&index=0&id=73e2bb3d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e2bb3d"]])

export default __exports__